import React, {MouseEvent} from 'react';

import CLMaskIcon from '../../CLMaskIcon/CLMaskIcon';
import iconsObj from '../../../assets/icons/iconsObj';

import styles from './CLModalHeader.module.scss';
import CLTooltipOnOverflow from '../../CLOverlayTrigger/overlays/CLTooltipOnOverflow/CLTooltipOnOverflow';
import classNames from 'classnames';
import addAutomationTag from 'common/src/modules/automation/utils/addAutomationTag';

function CLModalHeader({
  title,
  onClose,
  onDrag,
  qaHook = '',
}: {
  title: React.ReactNode;
  onClose: () => void;
  onDrag?: (e: MouseEvent) => void;
  qaHook?: string;
}) {
  return (
    <div
      className={classNames(styles.cl_modal_header, {[styles.draggable]: !!onDrag})}
      onWheel={(e) => e.stopPropagation()}
      onMouseDown={(e) => {
        e.stopPropagation();
        onDrag?.(e);
      }}
    >
      <CLTooltipOnOverflow>
        <div
          {...(qaHook && {
            ...addAutomationTag(`${qaHook}-modal-title`),
          })}
          className={styles.modal_title}
        >
          {title}
        </div>
      </CLTooltipOnOverflow>
      <CLMaskIcon
        {...(qaHook && {
          ...addAutomationTag(`${qaHook}-modal-close-button`),
        })}
        src={iconsObj.closeX}
        className={styles.modal_close_button}
        onClick={(e) => {
          e.stopPropagation();
          onClose();
        }}
      />
    </div>
  );
}

export default CLModalHeader;
